import { Box } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useMemo } from 'react'

import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { useGetTimeClockWithRelated } from '../../hooks/useGetTimeClockWithRelated/useGetTimeClockWithRelated'
import { useListTimeClockEntriesQuery } from '../../redux/api/timeClockApi'
import { CenteredLoading } from '../CenteredLoading/CenteredLoading'
import { CurrentTimeClockCardContent } from './CurrentTimeClockCardContent'
import { NewTimeClockCardContent } from './NewTimeClockCardContent'
import { SlideInCard } from './SlideInCard'

export const TimeClockProductivityCard = ({
  employeeId
}: {
  employeeId: string
}) => {
  const { accessToken, shopId } = useAccessTokenAndShopId()

  const { data: openTimeClocks, isLoading } = useListTimeClockEntriesQuery({
    authorization: accessToken,
    shop: shopId,
    employee: [employeeId],
    isOpenOnly: true
  })
  const openTimeClocksWithRelated = useGetTimeClockWithRelated(openTimeClocks)
  const openTimeClockWithRelated = useMemo(
    () => openTimeClocksWithRelated && openTimeClocksWithRelated[0],
    [openTimeClocksWithRelated]
  )
  const { data: latestClosedTimeClocks, isLoading: loadingLatest } =
    useListTimeClockEntriesQuery({
      authorization: accessToken,
      shop: shopId,
      employee: [employeeId],
      isClosedOnly: true,
      numResults: 1
    })
  const latestClosedTimeClocksWithRelated = useGetTimeClockWithRelated(
    latestClosedTimeClocks
  )
  const latestClosedTimeClockWithRelated = useMemo(
    () =>
      latestClosedTimeClocksWithRelated && latestClosedTimeClocksWithRelated[0],
    [latestClosedTimeClocksWithRelated]
  )

  if (isLoading || loadingLatest) {
    return <CenteredLoading />
  }
  const showOpenTimeClock = !!openTimeClockWithRelated
  const showClosedTimeClock =
    !showOpenTimeClock && !!latestClosedTimeClockWithRelated
  const showNewClockOnly = !showOpenTimeClock && !showClosedTimeClock

  return (
    <Box m={1}>
      <Grid container spacing={2} sx={{ maxWidth: 1200 }}>
        <Grid xs={12} sm={6}>
          <SlideInCard isIn={showOpenTimeClock}>
            {showOpenTimeClock && (
              <CurrentTimeClockCardContent
                timeClock={openTimeClockWithRelated}
              />
            )}
          </SlideInCard>
          <SlideInCard isIn={showClosedTimeClock}>
            {showClosedTimeClock && (
              <CurrentTimeClockCardContent
                timeClock={latestClosedTimeClockWithRelated}
              />
            )}
          </SlideInCard>
          <SlideInCard isIn={showNewClockOnly}>
            {showNewClockOnly && (
              <NewTimeClockCardContent
                latestTimeClock={undefined}
                {...{ employeeId }}
              />
            )}
          </SlideInCard>
        </Grid>
        <Grid xs={12} sm={6}>
          <SlideInCard isIn={showClosedTimeClock}>
            {showClosedTimeClock && (
              <NewTimeClockCardContent
                latestTimeClock={latestClosedTimeClockWithRelated}
                {...{ employeeId }}
              />
            )}
          </SlideInCard>
        </Grid>
      </Grid>
    </Box>
  )
}
